import('./index').catch((error) => {
  // Surface boot failures (share-scope version conflicts, remote load errors) instead of
  // leaving a silently blank checkout iframe.
  // eslint-disable-next-line no-console
  console.error('TravelDesk iframe: failed to initialize', error);
});
